// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file enums.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc } from '@bufbuild/protobuf/codegenv2'

/**
 * Describes the file enums.proto.
 */
export const file_enums: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CgtlbnVtcy5wcm90byqqAQoLTWVzc2FnZVR5cGUSGAoUVU5LTk9XTl9NRVNTQUdFX1RZUEUQABIOCgpPTkVfVE9fT05FEAESEAoMUFVCTElDX0dST1VQEAISEQoNUFJJVkFURV9HUk9VUBADEiAKHFNZU1RFTV9NRVNTQUdFX1BSSVZBVEVfR1JPVVAQBBISCg5DT01NVU5JVFlfQ0hBVBAFEhYKElNZU1RFTV9NRVNTQUdFX0dBUBAGKk0KC0ltYWdlRm9ybWF0EhgKFFVOS05PV05fSU1BR0VfRk9STUFUEAASBwoDUE5HEAESCAoESlBFRxACEggKBFdFQlAQAxIHCgNHSUYQBCpMChJDb21tdW5pdHlUb2tlblR5cGUSFgoSVU5LTk9XTl9UT0tFTl9UWVBFEAASCQoFRVJDMjAQARIKCgZFUkM3MjEQAhIHCgNFTlMQA2IGcHJvdG8z',
  )

/**
 * @generated from enum MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: UNKNOWN_MESSAGE_TYPE = 0;
   */
  UNKNOWN_MESSAGE_TYPE = 0,

  /**
   * @generated from enum value: ONE_TO_ONE = 1;
   */
  ONE_TO_ONE = 1,

  /**
   * @generated from enum value: PUBLIC_GROUP = 2;
   */
  PUBLIC_GROUP = 2,

  /**
   * @generated from enum value: PRIVATE_GROUP = 3;
   */
  PRIVATE_GROUP = 3,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_PRIVATE_GROUP = 4;
   */
  SYSTEM_MESSAGE_PRIVATE_GROUP = 4,

  /**
   * @generated from enum value: COMMUNITY_CHAT = 5;
   */
  COMMUNITY_CHAT = 5,

  /**
   * Only local
   *
   * @generated from enum value: SYSTEM_MESSAGE_GAP = 6;
   */
  SYSTEM_MESSAGE_GAP = 6,
}

/**
 * Describes the enum MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> =
  /*@__PURE__*/
  enumDesc(file_enums, 0)

/**
 * @generated from enum ImageFormat
 */
export enum ImageFormat {
  /**
   * @generated from enum value: UNKNOWN_IMAGE_FORMAT = 0;
   */
  UNKNOWN_IMAGE_FORMAT = 0,

  /**
   * Raster image files is payload data that can be read as a raster image
   *
   * @generated from enum value: PNG = 1;
   */
  PNG = 1,

  /**
   * @generated from enum value: JPEG = 2;
   */
  JPEG = 2,

  /**
   * @generated from enum value: WEBP = 3;
   */
  WEBP = 3,

  /**
   * @generated from enum value: GIF = 4;
   */
  GIF = 4,
}

/**
 * Describes the enum ImageFormat.
 */
export const ImageFormatSchema: GenEnum<ImageFormat> =
  /*@__PURE__*/
  enumDesc(file_enums, 1)

/**
 * @generated from enum CommunityTokenType
 */
export enum CommunityTokenType {
  /**
   * @generated from enum value: UNKNOWN_TOKEN_TYPE = 0;
   */
  UNKNOWN_TOKEN_TYPE = 0,

  /**
   * @generated from enum value: ERC20 = 1;
   */
  ERC20 = 1,

  /**
   * @generated from enum value: ERC721 = 2;
   */
  ERC721 = 2,

  /**
   * @generated from enum value: ENS = 3;
   */
  ENS = 3,
}

/**
 * Describes the enum CommunityTokenType.
 */
export const CommunityTokenTypeSchema: GenEnum<CommunityTokenType> =
  /*@__PURE__*/
  enumDesc(file_enums, 2)
